class CartDrawerSection extends HTMLElement {
    cartUpdateUnsubscriber = undefined;
    constructor() {
        super();

        this.cartType = this.dataset.cartType;
        this.drawerClass = "wt-cart__drawer";
        this.drawer = this.querySelector(`.${this.drawerClass}`);
        this.classDrawerActive = `${this.drawerClass}--open`;
        this.pageOverlayClass = "page-overlay-cart";
        this.activeOverlayBodyClass = `${this.pageOverlayClass}-on`;
        this.body = document.body;
        this.triggerQuery = [
            `.wt-cart__trigger`,
            `.wt-cart__back-link`,
            `.${this.pageOverlayClass}`,
        ].join(", ");
        this.triggers = () => document.querySelectorAll(this.triggerQuery);
        this.isOpen = false;
        this.isCartPage = window.location.pathname === window.routes.cart_url;
        this.closeButton = () => this.querySelector(".wt-cart__drawer__close");
        this.mainTrigger = document.querySelector(".wt-cart__trigger");
        this.toggleEelements = () =>
            this.querySelectorAll(this.dataset.toggleTabindex);
    }

    connectedCallback() {
        if (this.cartType === "page" || this.isCartPage) {
            document.addEventListener('cart-drawer:refresh', (e) => this.refreshCartDrawer(e))
            return;
        }

        this.init();
        this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
            if (this.isOpen) {
                setTabindex(this.toggleEelements(), "0");
                this.closeButton().focus();
            }
        });
    }

    disconnectedCallback() {
        if (this.cartUpdateUnsubscriber) {
            this.cartUpdateUnsubscriber();
        }
    }

    getFocusableElements() {
        const focusableElementsSelector =
            "button, [href], input, select, [tabindex]";
        const focusableElements = () =>
            Array.from(this.querySelectorAll(focusableElementsSelector)).filter(
                (el) => !el.hasAttribute("disabled") && el.tabIndex >= 0,
            );

        return {
            focusableElements,
            first: focusableElements()[0],
            last: focusableElements()[focusableElements().length - 1],
        };
    }

    temporaryHideFocusVisible() {
        document.body.classList.add("no-focus-visible");
    }

    onToggle() {
        if (this.hasAttribute("open")) {
            // cart closing
            this.removeAttribute("open");
            this.isOpen = false;
            this.mainTrigger.focus();
            this.temporaryHideFocusVisible();
            setTabindex(this.toggleEelements(), "-1");

            // stop scrolling
            this.querySelectorAll("scrolling-text").forEach(el => el.stopScroll());

        } else {
            // cart opening
            this.setAttribute("open", "");
            this.isOpen = true;
            this.closeButton().focus();
            this.temporaryHideFocusVisible();
            setTabindex(this.toggleEelements(), "0");

            // start scrolling
            this.querySelectorAll("scrolling-text").forEach(el => el.startScroll());
        }
    }


    toggleDrawerClasses() {
        this.onToggle();
        this.drawer.classList.toggle(this.classDrawerActive);
        this.body.classList.toggle(this.activeOverlayBodyClass);
    }

    init() {
        this.addEventListener("keydown", (e) => {
            const isTabPressed =
                e.key === "Tab" || e.keyCode === 9 || e.code === "Tab";
            const { first, last } = this.getFocusableElements();

            if (e.key === "Escape" || e.keyCode === 27 || e.code === "Escape") {
                if (this.isOpen) {
                    this.toggleDrawerClasses();
                }
            }

            if (isTabPressed) {
                if (e.shiftKey && document.activeElement === first) {
                    last.focus();
                    e.preventDefault();
                } else if (!e.shiftKey && document.activeElement === last) {
                    first.focus();
                    e.preventDefault();
                }
            }
        });

        this.triggers().forEach((trigger) => {
            trigger.addEventListener("click", (e) => {
                e.preventDefault();
                this.toggleDrawerClasses();
            });
        });

        this.addEventListener("click", (e) => {
            if (e.target.classList.contains("wt-cart__drawer__close")) {
                e.preventDefault();
                this.toggleDrawerClasses();
            }
        });

        document.addEventListener('cart-drawer:refresh', (e) => this.refreshCartDrawer(e))
    }

    renderContents(parsedState, isClosedCart = true) {
        this.getSectionsToRender().forEach((section) => {
            const sectionElement = section.selector
                ? document.querySelector(section.selector)
                : document.getElementById(section.id);
            sectionElement.innerHTML = this.getSectionInnerHTML(
                parsedState.sections[section.id],
                section.selector,
            );
        });

        // Scrolling Text
        let scrollingTextElements = this.querySelectorAll("scrolling-text");
        if (scrollingTextElements) {
          scrollingTextElements.forEach(el => el.startScroll());
        }
            
        if (isClosedCart) {
            setTimeout(() => {
                this.toggleDrawerClasses();
                if (this.isOpen) {
                    this.closeButton().focus();
                }
            });
        }

             let cartItems = document.querySelector('.cart-items-checkout');
            let shopifyCheckout = window.__showShopifyByTag;
            let userTimeZone = getUserTimezone();
            const INDIA_TZS = ['Asia/Kolkata', 'Asia/Calcutta'];
            const isIndia = INDIA_TZS.includes(userTimeZone); 
            var shiprocketBtn = document.querySelector('[data-cart-type="drawer"] #shiprocket-btn');
            var shopifyBtn = document.querySelector('[data-cart-type="drawer"] #CartDrawer-Checkout');
            var shopifyBtnNonBundle = document.querySelector('[data-cart-type="drawer"] button[name="checkout"]:not(.bundle-product-cta)');
            
            if (isIndia) {
                if (shopifyCheckout) {
                
                    if (shiprocketBtn) {
                        shiprocketBtn.style.display = "none"
                    }
                  
                    if (shopifyBtn) {
                        shopifyBtn.style.display = "block"
                    }
                    if (shopifyBtnNonBundle) {
                        shopifyBtnNonBundle.style.display = "none"
                    }
                } else {
                  
                    if (shiprocketBtn) {
                        shiprocketBtn.style.display = "block"
                    }
                 
                    if (shopifyBtn) {
                        shopifyBtn.style.display = "none"
                    }
                }
            } else {
              
                if (shiprocketBtn) {
                    shiprocketBtn.style.display = "none"
                }
           
                if (shopifyBtn) {
                    shopifyBtn.style.display = "block"
                }
            }
    }

    getSectionInnerHTML(html, selector = ".shopify-section") {
        return new DOMParser()
            .parseFromString(html, "text/html")
            .querySelector(selector).innerHTML;
    }

    getSectionsToRender() {
        return [
            {
                id: "cart-drawer",
                selector: "#CartDrawer",
            },
            {
                id: "cart-icon-bubble",
            },
        ];
    }

    refreshCartDrawer(e) {
        const sectionsToRender = this.getSectionsToRender();
        fetch(`${window.Shopify.routes.root}?sections=${sectionsToRender[0].id},${sectionsToRender[1].id}`)
            .then(response => response.json())
            .then((response) => {
                const parsedState = {
                    "sections": response
                }
                this.renderContents(parsedState, false);
            })
            .catch(e => {
                console.log(e)
            })
    }

    setActiveElement(element) {
        this.activeElement = element;
    }
}

customElements.define("cart-drawer", CartDrawerSection);

class CartDrawerItems extends CartItems {
    getSectionsToRender() {
        return [
            {
                id: "CartDrawer",
                section: "cart-drawer",
                selector: ".drawer__inner",
            },
            {
                id: "cart-icon-bubble",
                section: "cart-icon-bubble",
                selector: ".shopify-section",
            },
        ];
    }
}

customElements.define("cart-drawer-items", CartDrawerItems);

class ScrollingText extends HTMLElement {
  connectedCallback() {
    this.speed = this.dataset.speed ? parseInt(this.dataset.speed, 10) : 30; // px/s
    this.spacing = this.dataset.spacing ? parseInt(this.dataset.spacing, 10) : 100;

    // Wrap original content
    if (!this.querySelector(".scroll-inner")) {
      const content = this.innerHTML;
      this.innerHTML = `
        <div class="scroll-track">
          <div class="scroll-inner">${content}</div>
          <div class="scroll-inner">${content}</div>
        </div>
      `;
    }

    this.track = this.querySelector(".scroll-track");
    this.inner1 = this.querySelectorAll(".scroll-inner")[0];
    this.inner2 = this.querySelectorAll(".scroll-inner")[1];

    this._raf = null;
  }

  startScroll() {
    this.stopScroll();

    let position = 0;
    let lastTime = performance.now();

    const step = (time) => {
      const delta = time - lastTime;
      lastTime = time;

      // Move left continuously
      position -= (this.speed / 1000) * delta;

      const width = this.inner1.scrollWidth + this.spacing;

      // Reset position seamlessly
      if (position <= -width) {
        position += width;
      }

      this.track.style.transform = `translateX(${position}px)`;
      this._raf = requestAnimationFrame(step);
    };

    this._raf = requestAnimationFrame(step);
  }

  stopScroll() {
    if (this._raf) {
      cancelAnimationFrame(this._raf);
      this._raf = null;
    }
  }
}

if (!customElements.get("scrolling-text")) {
  customElements.define("scrolling-text", ScrollingText);
}
